<template>
  <div class="sole_prop_i">
    <PageContent>
      <StepsV2 :step="3" />
      <PanelV2
        type="w6"
        title="What's your BDO Settlement Account?"
        @nextClick="commitData()"
      >
        <template v-slot:title-solt>
          <!--
          <BdoProgress />
          -->
        </template>
        <template v-slot:content-solt>
          <AppForm
            ref="appForm"
            v-model="formData"
            :toggleContact="showAccount"
          />
        </template>
      </PanelV2>
    </PageContent>
  </div>
</template>

<script>
  import AppForm from "../forms/SolePropI.val";
  import API from "@/api";

  export default {
    name: 'SolePropI',
    pRouter: 'SolePropH',
    components: {
      AppForm,
    },
    data() {
      return {
        formData: {
          accountName: '',
          accountNumber: '',
          bankType: '',
        },
        showAccount: false,
      }
    },
    watch: {
      "formData.bankType": {
        handler(val) {
          this.showAccount = val !== "3" && val != '';
          if (val == '3') {
            this.formData.accountName = ''
            this.formData.accountNumber = ''
          } else {
            this.$nextTick(() => {
              this.$refs.appForm.$refs.appForm.clearValidate()
            })
          }
        },
        immediate: true
      }
    },
    methods: {
      commitData() {
        if(this.formData.bankType == '') {
          this.showMessageTip('Bank is error')
          return
        }
        this.$refs.appForm.$refs.appForm.validate((valid) => {

          if (valid) {
            const data = this.formatCommitData({...this.formData})

            API.addBdoProcess({
              ...data
            }).then(res => {
              if (res.success) {
                this.toNext()
              }
            })
          } else if (this.formData.bankType == '3') {
            const data = this.formatCommitData({...this.formData})
            API.addBdoProcess({
              ...data
            }).then(res => {
              if (res.success) {
                this.routerChange({name: 'SolePropN'})
              }
            })
          }
        });
      }
    }
  }
</script>


<style lang="scss">
.sole_prop_i {
  .content {
    & > div {
      min-height: 292px;
    }
  }
}
.el-form.SolePropI{
  margin-bottom: 54px !important;
  .el-form-item:nth-child(4) {
    margin-top: -120px;
  }
}
</style>
